<template>
  <div class="exchange-i">
    <Header title="毕业设计" type="0" route="/homeIndex"></Header>
    <NOdata
      v-if="this.designReCodeList && this.designReCodeList.length == 0"
      title="未查询到任何信息"
    ></NOdata>
    <div class="list-head" v-if="this.designReCodeList && this.designReCodeList.length > 0">
              <div>
                <p>学生学号：{{designReCodeList[0].studentnumber}}</p>
                <p>学生姓名：{{designReCodeList[0].studentname}}</p>
              </div>
     </div>
    <div class="exchange">
      <div
        class="item"
        v-for="(item, index) of designReCodeList"
        :key="index"
      >
        <ul>
          <li><label>年度：{{item.jb}}</label></li>
          <li><label>指导老师：{{item.teachername}}</label></li>
          <li><label>设计（论文）题目：{{item.topicname}}</label></li>
          <li>
            <label class="lableBut" style="float:left;width: 40%;text-align:right;padding: 0;margin: 0;"><a @click="toQustionOnload(item,'1')">在线提问</a></label>
            <label style="float:left;width: 20%;padding: 0;margin: 0;"></label>
            <label class="lableBut" style="float:right;width: 40%;padding: 0;margin: 0;"><a @click="toQustionOnload(item,'2')">线下指导</a></label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      designReCodeList: [],
    };
  },
  methods: {
    async loadMyDesignMsg(){
      const params = {
        //type: zdlx,
      };
      const res = await Api.loadMyDesignMsg(params);
      if(res.code=='1'){
        this.designReCodeList = res.data;
      }
    },
    toQustionOnload(item,type){
      this.$router.push({
          path: "/student/to_guideRecode",
          query: {
            ywstid: item.sj1104id,
            type:type
          }
        });
    },
    toGuideal(item){
      if(item.type=='2'){
        this.$router.push({
          path: "/design/guideDeal_unload",
          query: {
            ywstid: item.sj110401id,
          }
        });
      }else{
        this.$router.push({
          path: "/design/guideDeal",
          query: {
            ywstid: item.sj110401id,
          }
        });
      }
      
    }
  },
  created() {
    this.loadMyDesignMsg();
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .list-head {
      height: 60px;
      background-image: url("../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding-left: 6%;
      padding-top: 2%;
      box-sizing: border-box;
      margin-bottom: 1%;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      div {
        width: 90%;
        height: 100%;
        p {
          font-size: 14px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        
      
        span {
          
          align-items: center;
          i {
            font-style: normal;
            font-size: 14px;
            color: #fff;
            margin-right: 5%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 80%;
            margin-left: 15px;
          }
          b {
            display: inline-block;
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;
            border-top: 3px solid #fff;
          }
        }
      }
    }
  .exchange {
    padding: 5% 5% 0;
    overflow: auto;
    height: 70vh;
    .item {
      background: #f8f8f8;
      border-radius: 8px;
      margin: 0 auto 5%;
      padding: 3% 3% 3% 6%;
      box-sizing: border-box;

      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      ul {
        li {
          font-family: PingFangSC-Light;
          font-size: 14px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 2%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
          min-height: 16px;
        }

        li label {
          height: 16px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          line-height: 16px;
          margin-bottom: 1%;
          margin-top: 1%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
        }

        .lableBut{
          color: #0632f8;
          margin-top: 2%;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/Design/design.vue